<template>
  <div v-if="villa">
    <b-modal
      id="cv-villas-modal"
      ref="cv-villas-modal-ref"
      hide-footer
      title="Villa Information"
    >
      <div class="modal-banner-container" v-if="villa.images.length > 0">
        <template>
          <div>
            <h4 class="mt-3 orange">Gallery</h4>
            <b-carousel
              id="carousel-1"
              v-model="slide"
              :interval="0"
              controls
              indicators
              background="#ababab"
              img-width="1024"
              img-height="480"
              @sliding-start="onSlideStart"
              @sliding-end="onSlideEnd"
            >
              <div v-for="(image, index) in villa.images" :key="index">
                <b-carousel-slide :img-src="image"></b-carousel-slide>
              </div>
            </b-carousel>
          </div>
        </template>
        <div class="modal-banner-header-text">
          {{ villa.name }}
        </div>
        <div class="modal-banner-subheader-text">
          {{ villa.locationName }}
        </div>
      </div>
      <hr />
      <div>
        <h4 class="mt-3 orange text-center">Trailfinders View</h4>
        <div>
          <h4 class="mt-2 orange">Highlights</h4>
          <li
            v-for="(feature, index) in villa.features"
            :key="index"
            class="mx-0 px-0"
          >
            {{ feature }}
          </li>
        </div>

        <div class="mt-4">
          <h4 class="orange">About the Villa</h4>
          <div><p v-html="villa.aboutHtml"></p></div>
        </div>

        <h4 class="orange text-center">Villa Details</h4>

        <div class="mt-4">
          <h4 class="orange">Accommodation</h4>
          <div class="d-flex flex-wrap justify-content-between">
            <div
              v-for="(detail, index) in villa.details"
              :key="index"
              class="col-6 d-flex flex-column mb-3 px-0"
            >
              <p class="mb-1 font-weight-bold">{{ detail.title }}</p>

              <div v-if="detail.type === 'string'">
                <li>
                  {{ detail.data }}
                </li>
              </div>

              <div v-else-if="detail.type === 'array'">
                <li v-for="(detailItem, i) in detail.data" :key="i">
                  {{ detailItem }}
                </li>
              </div>
            </div>
          </div>
        </div>

        <div class="mt-4">
          <h4 class="orange">Facilities</h4>
          <div class="d-flex flex-wrap justify-content-between">
            <div
              class="col-6 d-flex flex-column mb-3 px-0"
              v-for="(facility, i) in villa.facilities"
              :key="i"
            >
              <p class="mb-1 font-weight-bold">{{ facility.title }}</p>
              <div v-if="facility.type === 'string'">
                <li>
                  {{ facility.data }}
                </li>
              </div>
              <div v-else-if="facility.type === 'array'">
                <li v-for="(facilityItem, i) in facility.data" :key="i">
                  {{ facilityItem }}
                </li>
              </div>
            </div>
          </div>
        </div>

        <div class="mt-4">
          <h4 class="orange">Service & Staffing</h4>
          <div class="d-flex flex-wrap justify-content-between">
            <div
              class="col-6 d-flex flex-column mb-3 px-0"
              v-for="(service, i) in villa.serviceStaffing"
              :key="i"
            >
              <p class="mb-1 font-weight-bold">
                {{ service.title ? capitalise(service.title) : "Included" }}
              </p>
              <div v-if="service.type === 'string'">
                <li>
                  {{ service.data }}
                </li>
              </div>
              <div v-else-if="service.type === 'array'">
                <li v-for="(serviceItem, i) in service.data" :key="i">
                  {{ serviceItem }}
                </li>
              </div>
            </div>
          </div>
        </div>

        <div class="mt-4">
          <h4 class="orange">Important Information</h4>
          <div class="important-info-container">
            <p v-html="villa.importantInfoHtml"></p>
          </div>
        </div>

        <div class="mt-4">
          <Map
            :mapData="villa.mapData"
            :initOnMount="true"
            :hideFoodMarkers="true"
          />
        </div>

        <div class="mt-4">
          <h4 class="orange">Location</h4>
          <div class="d-flex flex-wrap justify-content-between">
            <div
              class="col-6 d-flex flex-column mb-3 px-0"
              v-for="(loc, i) in villa.locationData"
              :key="i"
            >
              <p class="mb-1 font-weight-bold">
                {{ loc.title ? capitalise(loc.title) : "Included" }}
              </p>
              <div v-if="loc.type === 'string'">
                <li>
                  {{ loc.data }}
                </li>
              </div>
              <div v-else-if="loc.type === 'array'">
                <li v-for="(locItem, i) in loc.data" :key="i">
                  {{ locItem }}
                </li>
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>
<script>
import Map from "@/partials/map/map";

export default {
  components: {
    Map,
  },
  props: {
    villaData: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      villa: null,
      slide: 0,
      sliding: null,
    };
  },
  mounted() {
    setTimeout(() => {
      if (this.villaData) {
        this.formatVillaData();
      }
    }, 1000);
  },
  methods: {
    show() {
      this.$refs["cv-villas-modal-ref"].show();
    },
    formatVillaData() {
      const tmp = {};
      tmp.name = this.villaData.Name;
      tmp.locationName = this.villaData.Location;
      if (
        this.villaData.FormattedGallery &&
        this.villaData.FormattedGallery.length
      ) {
        // reduced image size
        tmp.images = this.villaData.FormattedGallery;
      } else {
        tmp.images = this.villaData.Gallery.Item.map((img) => img[0]);
      }
      tmp.features = this.villaData.InBriefFeatures.Item.map(
        (feature) => Array.isArray(feature[0]) ? feature[0] : feature
      );
      tmp.aboutHtml = this.villaData.AboutTheVilla["#cdata-section"];
      tmp.importantInfoHtml =
        this.villaData.ImportantInformation["#cdata-section"];
      tmp.details = Array.isArray( this.villaData.Accommodation.AccommodationFeatures) ? this.findNestedData(
        this.villaData.Accommodation.AccommodationFeatures,
        'AccommodationFeatures') : this.formatObjData(this.villaData.Accommodation.AccommodationFeatures);
      tmp.facilities = this.findNestedData(this.villaData.Facilities.Facility,
        'Facility');
      tmp.serviceStaffing = this.findNestedData(
        this.villaData.ServiceAndStaffing.Service,
        'ServiceStaffing'
      );
      tmp.locationData = this.findNestedData(
        this.villaData.LocationFeatures.Feature,
        'Feature'
      );
      tmp.mapData = {
        lat: parseFloat(this.villaData.Latitude),
        lng: parseFloat(this.villaData.Longitude),
        zoom: 14,
      };
      this.villa = tmp;
    },
    findNestedData(arr, type) {
      if (typeof arr === "object" && !Array.isArray(arr)) {
        if (Object.keys(arr).length > 0) {
          // if arr is actually an object then push into an array
          arr = [arr];
        }
        return [];
      }
      return arr
        .map((_item) => {
          const obj = {};
          let title = ""
          if (_item.Title) {
            title = _item.Title
          } else if (_item[0] && _item[0].Title ) {
            title = _item[0].Title
          }
          obj.title = this.capitalise(title);
          if (_item.Items && _item.Items.Item) {
            if (Array.isArray(_item.Items.Item)) {
              // some items are listed in an array. Some are a single string value
              obj.data = _item.Items.Item.map((_detail) => _detail);
              obj.type = "array";
            } else if (
              _item.Items &&
              _item.Items.Item &&
              typeof _item.Items.Item === "string"
            ) {
              obj.data = _item.Items.Item;
              obj.type = "string";
            } else {
              obj.data = null;
            }
          } 
          else if (_item[0] && _item[0].Items && _item[0].Items.Item) {
            if (Array.isArray(_item[0].Items.Item)) {
              // some items are listed in an array. Some are a single string value
              obj.data = _item[0].Items.Item.map((_detail) => _detail);
              obj.type = "array";
            } else if (
              _item[0].Items &&
              _item[0].Items.Item &&
              typeof _item[0].Items.Item === "string"
            ) {
              obj.data = _item[0].Items.Item;
              obj.type = "string";
            } else {
              obj.data = null;
            }
          } else {
            obj.data = null;
          }
          return obj;
        })
        .filter((_item2) => {
          // removes items with no value
          return _item2 && _item2.data && _item2.title && _item2.type;
        });
    },
    formatObjData(obj) {
      let formatObj = {
        data: obj.Items.item,
        title: obj.Title,
        type: 'array'
      }
      return [formatObj]
    },
    capitalise(str) {
      if (!str) {
        return str;
      }

      const splitStr = str.split(" ");
      return splitStr
        .map(
          (_str) =>
            `${_str.slice(0, 1).toUpperCase()}${_str.slice(1).toLowerCase()}`
        )
        .join(" ");
    },
    onSlideStart() {
      this.sliding = true;
    },
    onSlideEnd() {
      this.sliding = false;
    },
  },
};
</script>

<style>
.modal-banner-container {
  position: relative;
  text-align: center;
  color: white;
  font-weight: 500;
}

.modal-banner-header-text,
.modal-banner-subheader-text {
  position: absolute;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 80%;
  background-color: rgba(175, 171, 171, 0.5);
}
.modal-banner-header-text {
  font-size: 3vw;
  top: 30%;
}
.modal-banner-subheader-text {
  font-size: 1.5vw;
  top: 75%;
}
.vtd-center-image {
  display: block;
  margin-left: auto;
  margin-right: auto;
  width: 95% !important;
}
.orange {
  color: orange;
  font-weight: bolder;
}
.important-info-container {
  background-color: #dbdbdb;
  padding: 10px;
}
</style>
